
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import LoginPage from '@/pages/LoginPage';
import ProjectsPage from '@/pages/ProjectsPage';
import EditorPage from '@/pages/EditorPage';
import TemplateSelectPage from '@/pages/TemplateSelectPage';
import AuthGuard from '@/components/auth/AuthGuard';

export default function App() {
  return (
    <>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected */}
        <Route
          path="/"
          element={
            <AuthGuard>
              <ProjectsPage />
            </AuthGuard>
          }
        />
        <Route
          path="/ide/:workspaceId"
          element={
            <AuthGuard>
              <EditorPage />
            </AuthGuard>
          }
        />
        <Route
          path="/templates"
          element={
            <AuthGuard>
              <TemplateSelectPage />
            </AuthGuard>
          }
        />
      </Routes>

      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#252526',
            color: '#cccccc',
            border: '1px solid #333',
            fontSize: '13px',
          },
          success: {
            iconTheme: { primary: '#4ec9b0', secondary: '#252526' },
          },
          error: {
            iconTheme: { primary: '#f14c4c', secondary: '#252526' },
          },
        }}
      />
    </>
  );
}
